// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import { camelCase as _camelCase } from 'lodash';

import { getParams } from '../../../get-params';
import validateRequiredParams from '../../validate-required-params';
import { globalModalStore } from '@ion/global';
import yaml from 'js-yaml';
import { downloadConnection } from './download-connection';
import { removeUiFields } from './remove-ui-fields';
import { saveFile } from '@ion/components';

const uiFields = [
  'expressionName',
  'opId',
  'opIndex',
  '_path',
  'event',
  'schema',
  '_hide',
  'pipelineVar',
  'attachmentKey',
  'applyDefault',
];

// js-yaml's default 80-column wrap rewrites `|` code blocks (e.g. Lua) as `>` folded blocks; -1 disables it (0 does not).
const YAML_DUMP_OPTIONS = { lineWidth: -1 };

export const download = ({ playbookState, integration }) => {
  try {
    const params = getParams(playbookState.connectionJSON, playbookState.playbook);
    validateRequiredParams(params);
  } catch (e) {
    return globalModalStore.addNotification({
      title: 'Unable to download',
      message: 'Required parameters are missing. Please populate all required parameters and retry.',
      code: e,
    });
  }

  const content = {
    'connection.yaml': yaml.dump(
      downloadConnection(playbookState.connectionJSON, integration.starterkitId),
      YAML_DUMP_OPTIONS
    ),
    'playbook.yaml': yaml.dump(removeUiFields(playbookState.playbook, uiFields), YAML_DUMP_OPTIONS),
  };
  saveFile({
    compressFile: true,
    mimeType: 'text/json',
    content: content,
    filename: `${_camelCase(integration.name)}.zip`,
    compressionType: 'zip',
  });
};
